(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["spirittee-whitea-preview"] && !Shopify.designMode) return;
  try {
    (function(){
function init(){
const root=document.getElementById('TeaTribeJourney');
const dialog=document.getElementById('tt-whitea-dialog');
if(!root||!dialog||dialog.dataset.ready||!dialog.showModal)return;
dialog.dataset.ready='true';
let opener=null,previousOverflow='';
root.querySelectorAll('.tt-route-list a[href="/products/whitea"]').forEach(link=>{
link.setAttribute('aria-haspopup','dialog');
link.setAttribute('aria-controls',dialog.id);
link.removeAttribute('target');
link.addEventListener('click',event=>{
if(event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
event.preventDefault();opener=link;previousOverflow=document.body.style.overflow;
dialog.showModal();document.body.style.overflow='hidden';
});
});
dialog.querySelector('.tt-dialog-close').addEventListener('click',()=>dialog.close());
dialog.addEventListener('click',event=>{if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}});
dialog.addEventListener('close',()=>{document.body.style.overflow=previousOverflow;if(opener&&opener.isConnected)opener.focus();});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

})();
